import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/webhook/importer/webhookImporterActions';

export default importerReducers(actions);
